import { string2rbg } from './color';
/**
 * 返回一个线性插值器，接受数字
 * @param a 任意值
 * @param b 任意值
 * @returns 线性插值器
 */
export var createInterpolateNumber = function createInterpolateNumber(a, b) {
  return function (t) {
    return a * (1 - t) + b * t;
  };
};
export var createInterpolateColor = function createInterpolateColor(a, b) {
  var c1 = string2rbg(a);
  var c2 = string2rbg(b);
  if (c1 === null || c2 === null) return c1 ? function () {
    return a;
  } : function () {
    return b;
  };
  return function (t) {
    var values = new Array(4);
    for (var i = 0; i < 4; i += 1) {
      var from = c1[i];
      var to = c2[i];
      values[i] = from * (1 - t) + to * t;
    }
    var r = values[0],
      g = values[1],
      b = values[2],
      a = values[3];
    return "rgba(".concat(Math.round(r), ", ").concat(Math.round(g), ", ").concat(Math.round(b), ", ").concat(a, ")");
  };
};
/**
 * 返回一个线性插值器，接受数字和颜色
 * @param a 任意值
 * @param b 任意值
 * @returns 线性插值器
 */
export var createInterpolateValue = function createInterpolateValue(a, b) {
  if (typeof a === 'number' && typeof b === 'number') return createInterpolateNumber(a, b);
  if (typeof a === 'string' && typeof b === 'string') return createInterpolateColor(a, b);
  return function () {
    return a;
  };
};
/**
 * 返回一个 round 线性差值器，对输出值进行四舍五入
 * @param a 任意值
 * @param b 任意值
 * @returns 线性插值器
 */
export var createInterpolateRound = function createInterpolateRound(a, b) {
  var interpolateNumber = createInterpolateNumber(a, b);
  return function (t) {
    return Math.round(interpolateNumber(t));
  };
};